var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramOnline64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Online64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(3.000000, 1.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,29 L45,29 L45,44.5 C45,53.0604136 38.0564766,60 29.4921185,60 L28.5078815,60 C19.943115,60 13,53.0622958 13,44.5 L13,29 Z",
    id: "Mouse",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,13 L29,13 L29,29 L13,29 L13,21 C13,16.581722 16.581722,13 21,13 Z",
    id: "Focus",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,13 L45,13 L45,29 L29,29 L29,21 C29,16.581722 32.581722,13 37,13 Z",
    id: "Right-button",
    fill: "#FFFFFF",
    transform: "translate(37.000000, 21.000000) scale(-1, 1) translate(-37.000000, -21.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Emphasis",
    transform: "translate(0.772731, 0.025602)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.227268833,15.9743981 L8.22726883,15.9743981 L0.227268833,15.9743981 Z",
    id: "Emphasis-bottom"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2272688,8.97439814 L15.2272688,0.974398144 L15.2272688,8.97439814 Z",
    id: "Emphasis-top"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08082222,11.8634854 L7.08082222,3.37820407 L7.08082222,11.8634854 Z",
    id: "Emphasis-middle",
    transform: "translate(7.580822, 7.620845) rotate(-45.000000) translate(-7.580822, -7.620845) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramOnline64);
export default __webpack_public_path__ + "static/media/pictogramOnline64.7e0ee935f003844ffa56a0f909a5ad0f.svg";
export { ForwardRef as ReactComponent };